<div class="container flex-column" xmlns="http://www.w3.org/1999/html">
  <div class="d-flex justify-content-end mt-2">
  </div>
  <div class="riplay-title">
    <h2 class="text-center mt-5 color-blue"><b>ELLISE Sales Dashboard</b></h2>
  </div>
  <div class="container mt-5 pt-4 form-header bg-white">
  </div>
</div>
<div class="container form-container pb-3 bg-white text-center">
<!--  <div *ngIf="this.pageState == 'APPROVED'">-->
  <div>
    <div class="text-center">
      <img *ngIf="endorseResponse.statusId == 1" src="assets/Data-Berhasil-Disimpan-Icon.png">
      <img *ngIf="endorseResponse.statusId !== 1" src="assets/Diperlukan-Informasi-Tambahan-Icon.png">
    </div>
    <h2 class="color-light-blue" *ngIf="endorseResponse.statusId == 1"><b>Perubahan Tanggal Berhasil</b></h2>
    <h2 class="color-light-blue" *ngIf="endorseResponse.statusId !== 1"><b>Perubahan Tanggal Gagal</b></h2>
    <p class="color-light-blue">Tanggal Formulir : {{this.todayDate | date:"dd - M - Y"}}</p>
    <p class="bg-warning-subtle d-inline-block rounded-3 p-1 text-warning">No Referensi:
      <b>{{dataDashboard.referenceNo}}</b></p>
    <p class="bg-light rounded border shadow color-light-blue p-1 my-3" *ngIf="endorseResponse.statusId == 1" >Perubahan Tanggal Akad Kredit Berhasil</p>
    <p class="bg-light rounded border shadow color-light-blue p-1 my-3" *ngIf="endorseResponse.statusId == 1" >Surat Persetujuan Asuransi terbaru dapat diunduh melalui halaman ini atau dapat diunduh melalui halaman dashboard.</p>
    <p class="bg-light rounded border shadow color-light-blue p-1 my-3" *ngIf="endorseResponse.statusId !== 1">Perubahan Tanggal Akad Kredit tidak dapat dilakukan karena merubah nilai Premi Asuransi</p>
    <p class="bg-light rounded border shadow color-light-blue p-1 my-3" *ngIf="endorseResponse.statusId !== 1">Mohon untuk membuat pengajuan baru atau hubungi PIC Allianz</p>
    <div class="d-flex flex-column justify-content-center flex-gap">
      <div class="d-flex flex-column flex-gap">
<!--        <a class="btn btn-back mt-3 py-3 flex-grow-1" type="button" (click)="downloadAkseptasi()">-->
        <a #btnAcceptance [hidden]="true"></a>
        <a class="btn btn-back mt-3 py-3 flex-grow-1" type="button" *ngIf="endorseResponse.statusId == 1" (click)="downloadAkseptasi()">
<!--          <span *ngIf="this.isLoadingAkseptasi" class="spinner-border spinner-border-sm" role="status"-->
<!--                aria-hidden="true"></span>-->
<!--          <span class="spinner-border spinner-border-sm" role="status"-->
<!--                aria-hidden="true"></span>-->
          Unduh Surat Persetujuan Asuransi
        </a>
<!--        <a class="btn btn-back mt-3 py-3 flex-grow-1" type="button" (click)="toSpajkRiplay()">-->
<!--          &lt;!&ndash;          <span *ngIf="this.isLoadingAkseptasi" class="spinner-border spinner-border-sm" role="status"&ndash;&gt;-->
<!--          &lt;!&ndash;                aria-hidden="true"></span>&ndash;&gt;-->
<!--&lt;!&ndash;          <span class="spinner-border spinner-border-sm" role="status"&ndash;&gt;-->
<!--&lt;!&ndash;                aria-hidden="true"></span>&ndash;&gt;-->
<!--          Unduh SPAJK RIPLAY-->
<!--        </a>-->
      </div>
      <button class="btn btn-outline-warning bg-warning-subtle color-dark-orange mt-3 py-3 flex-grow-1" type="button" (click)="backToDashboard()">Kembali ke Dashboard</button>

      <button class="btn btn-continue mt-3 py-3 flex-grow-1" type="button" (click)="backToMenu()">Kembali ke Halaman
        Awal
      </button>
    </div>
  </div>
<!--  <div *ngIf="pageState=='REFERUW' || pageState=='SUBMITTED'">-->
<!--    <div class="text-center">-->
<!--      <img src="assets/Diperlukan-Informasi-Tambahan-Icon.png">-->
<!--    </div>-->
<!--    <h2 class="color-light-blue"><b>Lengkapi Dokumen via E-mail</b></h2>-->
<!--    <p class="color-light-blue">Tanggal Formulir : {{this.todayDate | date:"dd - M - Y"}}</p>-->
<!--    <p class="bg-warning-subtle d-inline-block rounded-3 p-1 text-warning">No Referensi:-->
<!--      <b>{{productInfo.referenceNumber}}</b></p>-->
<!--    <p class="bg-light rounded border shadow color-light-blue p-1 my-3">Silahkan cetak SPAJPK Syariah dan RIPLAY-->
<!--      Personal untuk ditandatangani oleh calon PYD dan harap menghubungi PIC Allianz untuk informasi lebih lanjut</p>-->
<!--    <div class="d-flex flex-column justify-content-center flex-gap">-->
<!--      <button class="btn btn-outline-warning bg-warning-subtle mt-3 py-3 flex-grow-1" type="button"-->
<!--              (click)="backToDashboard()">Menuju halaman Dashboard-->
<!--      </button>-->
<!--      <button class="btn btn-continue mt-3 py-3 flex-grow-1" type="button" (click)="backToMenu()">Kembali ke Halaman-->
<!--        Awal-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
</div>
